import DtoConverter from 'scripts/application/dto_converters/agent_assistance_config_converter';
import qconsole from 'scripts/lib/qconsole';
import TopicSuggestionsFetcher from 'actions/customer/lib/topic_suggestions_fetcher';

export default class AgentAssistanceConfigGatewayObserver {
  constructor(context) {
    this.context = context;
    this.topicSuggestionsFetcher = new TopicSuggestionsFetcher(context);
  }

  handleEntity(dto) {
    this.context.stores.agentAssistanceConfig.set(DtoConverter.fromDto(dto));
    this.topicSuggestionsFetcher.fetch();
  }

  handleRequestError(errorDto) {
    qconsole.log(`Unexpected error requesting agent assistance configuration ${JSON.stringify(errorDto)}`);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/configuration/agent_assistance_config_gateway_observer.js